<template>
  <div class="drift-container" v-show="haveDocket">
    <ul class="nav nav-actions nav-three-buttons">
      <li>
        <a @click="handleRotateLeft">
          <i class="fa fa-circle-o-notch fa-spin fa-fw" v-if="performingRotateLeft"></i>
          <i class="fa fa-rotate-left" v-else></i> 90° left
        </a>
      </li>
      <li>
        <a @click="handleRotateDouble">
          <i class="fa fa-circle-o-notch fa-spin fa-fw" v-if="performingRotateDouble"></i>
          <i class="fa fa-refresh" v-else></i> 180°
        </a>
      </li>
      <li>
        <a @click="handleRotateRight">
          <i class="fa fa-circle-o-notch fa-spin fa-fw" v-if="performingRotateRight"></i>
          <i class="fa fa-rotate-right" v-else></i> 90° right
        </a>
      </li>
    </ul>
    <img class="drift" alt="" :data-zoom="urlToDocketPreview" :src="urlToDocketPreview">
  </div>
</template>

<script>
  import { mapState, mapActions } from 'vuex'
  import { url } from 'utils'
  import Drift from 'drift-zoom'
  import Vue from 'vue'

  export default {
    data () {
      return {
        drift: null,
        urlToDocketPreview: null,
        performingRotateLeft: false,
        performingRotateRight: false,
        performingRotateDouble: false
      }
    },

    computed: {
      ...mapState('weighbridge/docket', ['docket']),

      haveDocket () {
        return this.docket.id !== null && this.docket.id !== undefined
      },

      docketHasPhoto () {
        return this.docket.id && this.docket.photo_path
      }
    },

    watch: {
      docket (docket) {
        this.triggerDockerPreview(docket)
      },

      urlToDocketPreview (val) {
        if (val) {
          this.drift.setZoomImageURL(val)
        }
      }
    },

    mounted () {
      this.drift = new Drift(document.querySelector('.drift'), {
        paneContainer: document.querySelector('.drift-container'),
        inlinePane: false,
        showWhitespaceAtEdges: false,
        inlineOffsetY: -85,
        containInline: true,
        hoverBoundingBox: false
      })

      this.triggerDockerPreview(this.docket)
    },

    methods: {
      ...mapActions('weighbridge/docket', ['rotateDocket']),

      triggerDockerPreview (docket) {
        if (docket.id && docket.photo_path) {
          this.urlToDocketPreview = url(`dockets/${docket.id}/preview`)
        }
      },

      handleRotate (amount, button) {
        if (!this.performingRotateLeft || !this.performingRotateDouble || !this.performingRotateRight) {
          this[`performingRotate${button}`] = true

          this.rotateDocket({ amount, id: this.docket.id }).then(this.updateDriftImages)
        }
      },

      /**
       * Update the drift options when a docket changes.
       *
       * @return void
       */
      updateDriftImages ({ data }) {
        Vue.nextTick(() => {
          this.urlToDocketPreview = `${url(data.url)}&time=${data.time}`
          this.performingRotateRight = false
          this.performingRotateLeft = false
          this.performingRotateDouble = false
        })
      },

      /**
       * Rotate the image 90 degrees to the left
       *
       * @return void
       */
      handleRotateLeft () {
        this.handleRotate(90, 'Left')
      },
      /**
       * Rotate the image 90 degrees to the right
       *
       * @return void
       */
      handleRotateRight () {
        this.handleRotate(-90, 'Right')
      },
      /**
       * Rotate the image 180 degrees
       *
       * @return void
       */
      handleRotateDouble () {
        this.handleRotate(180, 'Double')
      }
    }
  }
</script>



// WEBPACK FOOTER //
// LoadCheckModalPreview.vue?bf280e42